import {styled} from '@mui/material/styles';
import Button, {ButtonProps} from '@mui/material/Button';

const ButtonMenu = styled(Button)<ButtonProps>(({theme}) => ({
    display: 'flex',
    gap: theme.spacing(0.3),
    textDecoration: 'none',
}));

export default ButtonMenu;
